var LEXEND_FONT_LINK_ID = 'cedora-lexend-font-link';
var LEXEND_FONT_STYLE_ID = 'cedora-lexend-font-style';
var LEXEND_FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&display=swap';
var LEXEND_FONT_CSS =
  "* {\n" +
  "  font-family: 'Lexend', sans-serif !important;\n" +
  '}';

function injectLexendFontIntoDocument(iframeDoc) {
  if (!iframeDoc) return;

  var head = iframeDoc.head || iframeDoc.getElementsByTagName('head')[0];
  var mount = head || iframeDoc.body || iframeDoc.documentElement;
  if (!mount) return;

  if (!iframeDoc.getElementById(LEXEND_FONT_LINK_ID) && head) {
    var lexendLink = iframeDoc.createElement('link');
    lexendLink.id = LEXEND_FONT_LINK_ID;
    lexendLink.rel = 'stylesheet';
    lexendLink.href = LEXEND_FONT_HREF;
    head.appendChild(lexendLink);
  }

  if (!iframeDoc.getElementById(LEXEND_FONT_STYLE_ID)) {
    var styleTag = iframeDoc.createElement('style');
    styleTag.id = LEXEND_FONT_STYLE_ID;
    styleTag.textContent = LEXEND_FONT_CSS;
    mount.appendChild(styleTag);
  }
}

function canAccessIframe(frame) {
  var sandbox = frame.getAttribute('sandbox');
  if (sandbox !== null && !sandbox.includes('allow-same-origin')) return false;
  try {
    return !!(frame.contentDocument || frame.contentWindow.document);
  } catch (e) {
    return false;
  }
}

function applyLexendFontToIframe(frame) {
  try {
    if (!canAccessIframe(frame)) return;
    injectLexendFontIntoDocument(
      frame.contentDocument || frame.contentWindow.document
    );
  } catch (e) {
    // Cross-origin or unloaded iframe — ignore
  }
}

function bindIframeLoadHandler(frame) {
  if (frame.dataset.cedoraLexendBound === '1') return;
  frame.dataset.cedoraLexendBound = '1';
  frame.addEventListener('load', function () {
    // New document replaces prior <link>/<style>; reinject once.
    applyLexendFontToIframe(frame);
  });
}

function applyLexendFontToIframes() {
  document.querySelectorAll('iframe').forEach(function (frame) {
    bindIframeLoadHandler(frame);
    applyLexendFontToIframe(frame);
  });
}

function startLexendIframeWatcher() {
  if (!document.body) return;

  applyLexendFontToIframes();

  var scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyLexendFontToIframes();
    });
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (node.tagName === 'IFRAME' || node.querySelector?.('iframe')) {
          scheduleApply();
          return;
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startLexendIframeWatcher);
} else {
  startLexendIframeWatcher();
}

window.addEventListener('load', applyLexendFontToIframes);
